export default __webpack_public_path__ + "static/media/mark.ae6e091c.svg";